<template>
  <b-modal id="createEXCMTaskModal" size="xl" hide-footer @hidden="resetData">
    <b-row slot="modal-header">
      <b-col>
        <h6>{{ $t('buttons.finishLastTaskAndClose') }}</h6>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <EXCMTaskCreate :caseIri="caseIri"></EXCMTaskCreate>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import EXCMTaskCreate from '../Create.vue'
export default {
  name: 'CreateEXCMTaskModal',
  components: {
    EXCMTaskCreate
  },
  computed: {
    show () {
      return this.$store.state.modals.excmtask.create.show
    },
    close () {
      return this.$store.state.modals.excmtask.create.close
    },
    caseIriStore () {
      return this.$store.state.modals.excmtask.create.caseIri
    }
  },
  watch: {
    'show': function (val) {
      this.openModal()
    },
    'close': function (val) {
      this.closeModal()
    }
  },
  data () {
    return {
      action: null,
      caseIri: null
    }
  },
  methods: {
    openModal () {
      if (this.show === 1 && this.caseIriStore) {
        this.caseIri = this.$store.state.modals.excmtask.create.caseIri
        this.$store.state.modals.excmtask.create.show = 0
        this.$store.state.modals.excmtask.create.caseIri = null
        this.$bvModal.show('createEXCMTaskModal')
      }
    },
    closeModal () {
      if (this.close === 1) {
        this.$store.state.modals.excmtask.create.close = 0
        this.$bvModal.hide('createEXCMTaskModal')
      }
    },
    resetData () {
      // console.log()
    }
  }
}
</script>
